import { Dialog, DialogTitle } from "@mui/material";
import { useState, useEffect } from "react";
import SimpleView from "./SimpleView";
import SplitView from "./SplitView";

export default function TransactionDialog({ 
  row, 
  rnrs, 
  onClose, 
  onConfirm, 
  onUpgrade, 
  onDowngrade, 
  onRemove,
  onSaveSplit // Uus callback spliti jaoks
}) {
  const [isSplitView, setIsSplitView] = useState(false);

  // Kui aken suletakse/avatakse uue reaga, lähtesta vaade
  useEffect(() => {
    // if (row has splits)
    if (row?.splits?.length) {
      setIsSplitView(true);
    } else {
      setIsSplitView(false);
    }
  }, [row]);

  if (!row) return null;

  return (
    <Dialog 
      open={!!row} 
      onClose={onClose} 
      fullWidth 
      maxWidth={isSplitView ? "md" : "sm"}
    >
      <DialogTitle>
        {isSplitView ? "Tehingu tükeldamine (Split)" : "Filtri haldus ja seadistamine"}
      </DialogTitle>

      {isSplitView ? (
        <SplitView 
          row={row} 
          rnrs={rnrs} 
          onBack={() => setIsSplitView(false)} 
          onClose={onClose}
          onSave={(splits) => {
            onSaveSplit(row.bank_ref, splits);
            onClose();
          }}
        />
      ) : (
        <SimpleView 
          row={row} 
          rnrs={rnrs} 
          onOpenSplit={() => setIsSplitView(true)}
          onClose={onClose}
          onConfirm={onConfirm}
          onUpgrade={onUpgrade}
          onDowngrade={onDowngrade}
          onRemove={onRemove}
        />
      )}
    </Dialog>
  );
}